import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EbayItemViewModel } from '../ItemGridModel';

interface ItemsState {
    items: EbayItemViewModel[];
}

const initialState: ItemsState = {
    items: [],
};

const itemTableSlice = createSlice({
    name: 'items',
    initialState,
    reducers: {
        addItems(state, action: PayloadAction<EbayItemViewModel[]>) {
            state.items = [...action.payload, ...state.items].slice(0, 5000); // Keep the last 5000 items
        },
        clearItems(state) {
            state.items = [];
        },
    },
});

export const { addItems, clearItems } = itemTableSlice.actions;

export default itemTableSlice.reducer;
